import { render, staticRenderFns } from "./CartCourseBuy.vue?vue&type=template&id=34062e90&scoped=true"
import script from "./CartCourseBuy.vue?vue&type=script&lang=js"
export * from "./CartCourseBuy.vue?vue&type=script&lang=js"
import style0 from "./CartCourseBuy.vue?vue&type=style&index=0&id=34062e90&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34062e90",
  null
  
)

export default component.exports